import {siteInit} from "@khan/app-shell";
import {mobileAppSentryIntegration} from "@khan/mobile-app-integration";

import reactMount from "#rendering/react-mount.tsx";

import App from "./app.tsx";
import {setupUrlConstruction} from "./setup-url-construction.ts";

// This makes sure our URL construction rules are configured for the app.
setupUrlConstruction();

siteInit({
    sentryIntegrations: [
        // This integration ensures that any captured exceptions are also
        // reported to the mobile app.
        mobileAppSentryIntegration(),
    ],
    sentryDsn:
        "https://0d3382554dd24dc998a5937351b12379@o8287.ingest.sentry.io/15744",
});

reactMount(App, "app-shell-root");
